<template>
  <div class="grid-container sm:justify-center py-14">
    <div class="flex justify-center w-full">
      <div class="bdt-prose ">
        <h1>
          Pol&iacute;tica de privacidad acceso a la Bolsa De Trabajo
        </h1>
        <h2>Condiciones Generales</h2>
        <ul>
          <li>
            La siguiente es la pol&iacute;tica de privacidad y t&eacute;rminos de uso de la BOLSA DE
            TRABAJO. El objetivo es informar a todos los usuarios y clientes acerca de la forma en
            que procesamos y tratamos los datos e informaci&oacute;n que nos brindan.
          </li>
          <li>
            La BOLSA DE TRABAJO, manifiesta que reconoce como un derecho del usuario la
            actualizaci&oacute;n, modificaci&oacute;n o eliminaci&oacute;n de aquella
            informaci&oacute;n que haya suministrado y se compromete a tener los procedimientos
            apropiados a efecto de ejecutar los cambios requeridos. De la misma forma, nos
            comprometemos a suprimir de la Base de Datos al usuario que as&iacute; lo solicite.
          </li>
        </ul>
        <h2>Detalle de informaci&oacute;n que se solicita</h2>
        <ul>
          <li>
            En la BOLSA DE TRABAJO, el usuario deber&aacute; registrarse previamente mediante un
            formulario para acceder a su contenido. Los datos facilitados en el formulario
            &nbsp;deben ser reales, veraces, completos y actualizados.
          </li>
          <li>
            En este formulario se le solicitar&aacute; informaci&oacute;n personal que ser&aacute;
            utilizada por la BOLSA DE TRABAJO, &uacute;nicamente para ser almacenado en una Base de
            Datos con un inter&eacute;s general de conocer a nuestras audiencias y para que la
            empresa reclutadora pueda revisar su perfil para definir si es la persona id&oacute;nea
            para participar en el proceso.
          </li>
          <li>
            Tambi&eacute;n se podr&aacute; recolectar informaci&oacute;n general no personal, de tal
            forma que garantizamos la no vinculaci&oacute;n de datos de manera directa con la
            persona.
          </li>
          <li>
            Otro tipo de informaci&oacute;n puede ser facilitada de manera voluntaria por los
            usuarios por medio de encuestas o promociones, lo cual depende exclusivamente de la
            voluntad de los usuarios.
          </li>
        </ul>
        <h2>
          Fines para los que se solicita la informaci&oacute;n
        </h2>
        <ul>
          <li>
            En primera instancia, al registrarse en nuestra Base de Datos, cada usuario
            recibir&aacute; un correo de bienvenida, que valida la creaci&oacute;n de su cuenta en
            la BOLSA DE TRABAJO.
          </li>
          <li>
            Los fines espec&iacute;ficos, para los cuales se recolecta la informaci&oacute;n de
            contacto son los siguientes: podr&aacute; ser utilizada por la BOLSA DE TRABAJO para
            conocer el comportamiento e intereses de los usuarios y mejorar los productos, servicios
            y/o publicidad.
          </li>
        </ul>
        <p>
          Asimismo, la informaci&oacute;n recolectada puede ser utilizada por las empresas
          reclutadoras para conocer a los postulantes al puesto de trabajo y definir si es la
          persona correcta para continuar el proceso de selecci&oacute;n y contactarles.
        </p>
        <ul>
          <li>
            Se reitera entonces que, bajo el consentimiento informado que se otorgue, los usuarios
            que se hayan registrado en la Base de Datos, y afiliado a ciertos servicios o productos
            podr&aacute;n recibir informaci&oacute;n relacionada con los mismos, mensajes de
            cumplea&ntilde;os, informaci&oacute;n sobre eventos especiales, correos
            electr&oacute;nicos en fechas especiales y otros que impliquen informaci&oacute;n de
            productos del BOLSA DE TRABAJO.
          </li>
          <li>
            Al registrarse, los usuarios aceptar&aacute;n expresamente estos env&iacute;os y el
            tratamiento de sus datos conforme se indica, todo lo anterior en relaci&oacute;n directa
            con los productos o servicios en los cuales cada usuario se registre.
          </li>
        </ul>
        <h2>Transmisi&oacute;n de datos a terceros</h2>
        <ul>
          <li>
            &Uacute;nicamente se comparte la informaci&oacute;n de los usuarios registrados que se
            encuentren aplicando a una oportunidad laboral de alguna empresa que se encuentre
            ofertando plazas en la misma plataforma.
          </li>
          <li>
            La BOLSA DE TRABAJO, no vende, alquila ni comparte con terceros ajenos a la plataforma
            la informaci&oacute;n personal de los usuarios registrados.
          </li>
          <li>
            Se except&uacute;an los casos en que la informaci&oacute;n es requerida por autoridades
            judiciales o administrativas competentes. En tal situaci&oacute;n, la BOLSA DE TRABAJO,
            se encuentra en obligaci&oacute;n legal de cumplir con los requerimientos de estos
            entes.
          </li>
          <li>
            La BOLSA DE TRABAJO, &nbsp;puede disponer y/o transmitir la informaci&oacute;n de los
            usuarios almacenada en sus bases de datos a un tercero que adquiera la titularidad u
            operaci&oacute;n de los servicios relacionados con el sitio web, sea de manera parcial o
            total. En caso de ocurrir, esta circunstancia ser&aacute; anunciada en el sitio web
            garantizando a los usuarios que cualquier cambio en las pol&iacute;ticas de privacidad
            ser&aacute; comunicado oportunamente.
          </li>
          <li>
            Asimismo, La BOLSA DE TRABAJO, puede compartir informaci&oacute;n an&oacute;nima
            colectiva con las empresas del Grupo, sobre los visitantes de La BOLSA DE TRABAJO para
            efectos de estad&iacute;sticas y valoraci&oacute;n de nuevos servicios.
          </li>
        </ul>
        <h2>
          Protecci&oacute;n de la informaci&oacute;n en la red
        </h2>
        <ul>
          <li>
            La BOLSA DE TRABAJO, ha implementado todas las medidas de seguridad razonables para la
            protecci&oacute;n de la informaci&oacute;n de los usuarios con el fin de evitar el uso
            indebido, manipulaci&oacute;n o acceso no autorizado a dicha informaci&oacute;n.
          </li>
          <li>
            Los sitios en Internet de la BOLSA DE TRABAJO, utilizan cookies, as&iacute; como otras
            tecnolog&iacute;as, para identificar el comportamiento de navegaci&oacute;n de los
            usuarios en los sitios de su propiedad.
          </li>
          <li>
            Los usuarios pueden configurar su programa o herramienta de navegaci&oacute;n en
            Internet para controlar si aceptan o rechazan tales medidas, como cookies, o para que
            les informen cada vez que las cookies son enviadas.
          </li>
          <li>
            Los usuarios entienden y aceptan que algunos de los productos y/o servicios
            podr&iacute;an estar dirigidos a personas mayores de 18 a&ntilde;os, por lo que la
            supervisi&oacute;n parental es requerida.
          </li>
          <li>
            La pol&iacute;tica de privacidad puede ser revisada y modificada por la BOLSA DE
            TRABAJO, en cualquier momento. Se notificar&aacute;n los cambios efectuados en la misma;
            sin embargo, los usuarios podr&aacute;n consultar y/o revisar peri&oacute;dicamente la
            pol&iacute;tica de privacidad as&iacute; como los T&eacute;rminos y condiciones de uso
            de la BOLSA DE TRABAJO.
          </li>
        </ul>
        <hr />
        <h2>Consentimiento informado del usuario</h2>
        <p>
          Al aceptar el presente documento usted reconoce que: i) Ha le&iacute;do y entendido los
          alcances de esta Pol&iacute;tica de Privacidad y T&eacute;rminos de Uso, ii) No tiene
          dudas relacionadas con la forma, medio y fin para el cual se le ha solicitado la
          informaci&oacute;n en el sitio. iii) Acepta expresamente, en forma voluntaria, su registro
          en el sitio. iv) Autoriza el uso de la informaci&oacute;n otorgada seg&uacute;n fue
          detallado y de acuerdo con los productos y servicios afiliados.
        </p>
        <p>
          Si tiene alguna duda que le inhibe de aceptar esta pol&iacute;tica y t&eacute;rminos de
          uso, puede o escribirnos al correo
          <a href="mailto:hola@laprensagrafica.com">hola@bolsadetrabajo.sv</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'

export default {
  name: 'TermsAndConditions',
  layout: Layout,
}
</script>
